import paid from './invoices/paid'
import calendarChannels from './calendars/channels'
import router from './router'
import draftPersist from './dossierItems/draftPersist'
export default [...paid,...calendarChannels, ...router, ...draftPersist];
